import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import * as Sentry from "@sentry/react";

import { App } from "./App.tsx";
import "./index.scss";
import { ErrorPage } from "./pages/ErrorPage.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { SendersPage } from "./pages/SendersPage.tsx";
import { TemplateEditionPage } from "./pages/TemplateEditionPage.tsx";
import { TemplatesPage } from "./pages/TemplatesPage.tsx";

Sentry.init({
  dsn: Config.dsn,
  environment: Config.envName,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api\.messaging\.takima\.io/,
    /^https:\/\/api\.messaging\.takima\.cloud/,
    /^https:\/\/api\.messaging\.takima\.dev/
  ],
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <HomePage />
      },
      {
        path: "/senders",
        element: <SendersPage />
      },
      {
        path: "/templates",
        element: <TemplatesPage />
      },
      {
        path: "/templates/:templateId",
        element: <TemplateEditionPage />
      },
      {
        path: "*",
        element: (
          <ErrorPage
            code={404}
            title={"Page Not Found"}
            description={"The page you are looking for does not exist."}
          />
        )
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById("root")!).render(<RouterProvider router={router} />);
